import { render, staticRenderFns } from "./BuildBenefit.vue?vue&type=template&id=bd11b612&"
import script from "./BuildBenefit.vue?vue&type=script&lang=ts&"
export * from "./BuildBenefit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports